module.exports = __webpack_public_path__ + "img/shuoming.6e30a21b.png";